module.exports = "<div class=\"loading-indicator\">\n  <mat-progress-spinner mode=\"indeterminate\" color=\"accent\"></mat-progress-spinner>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/busy-spinner/busy-spinner.component.html
// module id = ./src/app/busy-spinner/busy-spinner.component.html
// module chunks = main